import React from 'react';

import { TCurrentErrorType } from '../../../../interfaces/errorHandler';
import WhiteNoise from '../WhiteNoise';
import ErrorIcon from './ErrorIcon';

interface IObjectLiteral {
  [key: string]: any;
}

interface IProps {
  currentErrorType: TCurrentErrorType;
  currentErrorMessage: string;
}

const ErrorOverlay: React.FC<IProps> = (props: IProps) => {
  const { currentErrorType, currentErrorMessage } = props;

  const gandalf = window.location.origin + '/gandalf.gif';
  console.log('%c ', `padding:200px 480px 0 0; background:url(${gandalf}) no-repeat;`);

  const defineErrorMessage = () => {
    if (currentErrorType === 'api') {
      const messages: IObjectLiteral = {
        notFound: 'Vídeo não encontrado.',
        unauthorized: 'Sem autorização para acessar o vídeo.',
        paymentRequired: 'Vídeo indisponível.',
        badToken: 'Acho que você não é Safe ¯\\_(ツ)_/¯.',
        deviceNotSupported: 'Dispositivo não suportado.', // TODO: Adicionar Link para FAQ quando existir
        defaultError: '',
        preconditionFailed: 'Domínio não autorizado.'
      }

      return messages[currentErrorMessage]
    }

    return currentErrorMessage;
  }

  const errorMessage = defineErrorMessage();

  return (
    <WhiteNoise>
      <section style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(0, 0, 0, .8)',
        fontFamily: 'Roboto, sans-serif'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}>
          <ErrorIcon
            fill="#FF655F"
            height="3.25em"
          />

          <div style={{
            textAlign: 'center',
            color: '#dedede',
            marginTop: 16,
          }}>
            <strong
              style={{
                fontSize: '1.5em',
                display: 'block'
              }}
            >
              Parece que algo deu errado!
            </strong>
            <small style={{
              fontSize: '1.25em',
              display: 'block'
            }}>
              {errorMessage}
            </small>
          </div>
        </div>

      </section>
    </WhiteNoise>

  );
}

export default ErrorOverlay;
